import { jsx as _jsx } from "react/jsx-runtime";
import { getColorAndBackground } from "../../constants/Helper";
import { Chip } from "@mui/material";
export const HChip = ({ label, value }) => {
    const { color, background } = getColorAndBackground(value ?? label);
    return (_jsx(Chip, { title: label, size: "medium", label: label, style: { color: color, background: background, borderRadius: '10px', } }));
};
